module.exports = __webpack_public_path__ + "img/slide02-reciclaton.1cdd7d82.jpg";